// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card {
  min-height: 120px;
  margin: 16px 0 0 0;
  padding: 16px;
  width: 100%;
  box-shadow: rgba(0, 0, 0, 0.11) 0px 3px 13px;
}
ion-card ion-card-header {
  padding: 0px;
}
ion-card ion-card-header .icon-type {
  float: left;
  width: 24px;
  height: 24px;
  margin-top: 5px;
}
ion-card ion-card-header .pending {
  color: #00b6e3;
}
ion-card ion-card-header .payment {
  color: #00b400;
}
ion-card ion-card-header .icon-close {
  float: right;
  width: 20px;
  height: 20px;
}
ion-card ion-card-header ion-card-subtitle {
  font-size: 14.99px;
  color: #0c2340;
  font-weight: 600;
  text-transform: capitalize;
  left: 10px;
  top: 8px;
}
ion-card ion-card-content {
  padding-inline-start: 0px;
  padding-inline-end: 0px;
  padding-bottom: 8px;
}
ion-card ion-card-content .message {
  text-align: left;
  font-weight: 500;
  margin: 10px 0px 0px 34px;
  font-size: 13.99px;
}
ion-card ion-card-content .detail {
  text-align: left;
  font-weight: 500;
  margin: 2px 0px 0px 34px;
  font-size: 13.99px;
  font-weight: bold;
}
ion-card ion-card-content div {
  padding: 0px 16px;
}
ion-card ion-card-content .btn-single {
  width: 100%;
  min-height: 40px;
  margin: 16px 0px 0px 0px;
}
ion-card ion-card-content .btn-options {
  width: 45%;
  min-height: 40px;
  margin: 16px 5px 0px 5px;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/panel-core/lib/components/notifications-component/notifications-component.scss"],"names":[],"mappings":"AACE;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,4CAAA;AAAJ;AAEI;EACE,YAAA;AAAN;AAEM;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAAR;AAGM;EACE,cAAA;AADR;AAIM;EACE,cAAA;AAFR;AAKM;EACE,YAAA;EACA,WAAA;EACA,YAAA;AAHR;AAMM;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,0BAAA;EACA,UAAA;EACA,QAAA;AAJR;AAQI;EAEE,yBAAA;EAEA,uBAAA;EACA,mBAAA;AANN;AAQM;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AANR;AASM;EACE,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,iBAAA;AAPR;AAUM;EACE,iBAAA;AARR;AAWM;EACE,WAAA;EACA,gBAAA;EACA,wBAAA;AATR;AAYM;EACI,UAAA;EACA,gBAAA;EACA,wBAAA;AAVV","sourcesContent":["\n  ion-card {\n    min-height: 120px;\n    margin: 16px 0 0 0;\n    padding: 16px;\n    width: 100%;\n    box-shadow: rgb(0 0 0 / 11%) 0px 3px 13px;\n\n    ion-card-header {\n      padding: 0px;\n\n      .icon-type {\n        float: left;\n        width: 24px;\n        height: 24px;\n        margin-top: 5px;\n      }\n\n      .pending{\n        color: #00b6e3;\n      }\n\n      .payment{\n        color: #00b400;\n      }\n\n      .icon-close{\n        float: right;\n        width: 20px;\n        height: 20px;\n      }\n\n      ion-card-subtitle {\n        font-size: 14.99px;\n        color: #0c2340;\n        font-weight: 600;\n        text-transform: capitalize;\n        left: 10px;\n        top: 8px;\n      }\n    }\n\n    ion-card-content{\n      -webkit-padding-start: 0px;\n      padding-inline-start: 0px;\n      -webkit-padding-end: 0px;\n      padding-inline-end: 0px;\n      padding-bottom: 8px;\n\n      .message{\n        text-align: left;\n        font-weight: 500;\n        margin: 10px 0px 0px 34px;\n        font-size: 13.99px;\n      }\n\n      .detail{\n        text-align: left;\n        font-weight: 500;\n        margin: 2px 0px 0px 34px;\n        font-size: 13.99px;\n        font-weight: bold;\n      }\n\n      div{\n        padding: 0px 16px;\n      }\n      \n      .btn-single{\n        width: 100%;\n        min-height: 40px;\n        margin: 16px 0px 0px 0px;\n      }\n\n      .btn-options {\n          width: 45%;\n          min-height: 40px;\n          margin: 16px 5px 0px 5px;  \n      }\n      \n    }\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
